import { useState } from "react";
import { Tooltip } from "reactstrap";

const DeprecatedTooltip = (props: { id: string; container?: string }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <>
      <span className={"k-icon k-i-warning k-color-error"} id={props.id} style={{ cursor: "pointer" }} />
      <Tooltip
        isOpen={tooltipOpen}
        target={props.id}
        toggle={toggle}
        container={props.container ?? ".containerImage"}
        placement="auto"
      >
        Denna bild ska fasas ut och bör därför inte användas vid nyproduktion.
      </Tooltip>
    </>
  );
};
export default DeprecatedTooltip;
